import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { jugadoresAPI, statsAPI, medicionesAPI } from "../services/api";

export function useJugadores(academiaId?: string, categoria?: string) {
  return useQuery({
    queryKey: ["jugadores", academiaId, categoria],
    queryFn: () => jugadoresAPI.listar({ academia_id: academiaId, categoria }).then(r => r.data),
  });
}
export function useJugadorPerfil(id: string) {
  return useQuery({
    queryKey: ["jugador-perfil", id],
    queryFn: () => jugadoresAPI.perfil(id).then(r => r.data),
    enabled: !!id,
  });
}
export function useJugadorStats(id: string) {
  return useQuery({
    queryKey: ["jugador-stats", id],
    queryFn: () => jugadoresAPI.stats(id).then(r => r.data),
    enabled: !!id,
  });
}
export function useHistoricoFisico(id: string) {
  return useQuery({
    queryKey: ["historico-fisico", id],
    queryFn: () => jugadoresAPI.historicoFisico(id).then(r => r.data),
    enabled: !!id,
  });
}
export function useRegistrarStats() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: any) => statsAPI.registrar(data),
    onSuccess: (_, v) => qc.invalidateQueries({ queryKey: ["jugador-stats", v.jugador_id] }),
  });
}
export function useRegistrarMedicion() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: any) => medicionesAPI.registrar(data),
    onSuccess: (_, v) => qc.invalidateQueries({ queryKey: ["historico-fisico", v.jugador_id] }),
  });
}
